import React, { PropTypes } from 'react';
import { reduxForm } from 'redux-form';
import UploadPrematchedPairsForm from './UploadPrematchedPairsForm';
import { storeWithExpiration } from '../../utils/common';

const FORM_ID = 'accountPairsform';

export class UploadPrematchedAccountPairs extends React.Component {
  static propTypes = {
    orderId: PropTypes.string.isRequired,
    pristine: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
    uploadPrematchedPairsFunction: PropTypes.func.isRequired,
  };

  accountUploadFunction = params => {
    const { orderId, uploadPrematchedPairsFunction } = this.props;
    const token = storeWithExpiration.get('token');
    uploadPrematchedPairsFunction(orderId, 'account', params.accountPairsFile[0], token);
  };

  render() {
    const { pristine, handleSubmit, submitting, reset } = this.props;

    return (
      <UploadPrematchedPairsForm
        formId={FORM_ID}
        fieldName="accountPairsFile"
        fieldLabel="Account Pairs File"
        pristine={pristine}
        handleSubmit={handleSubmit}
        uploadFunction={this.accountUploadFunction}
        submitting={submitting}
        reset={reset}
      />
    );
  }
}

export default reduxForm({
  form: FORM_ID,
})(UploadPrematchedAccountPairs);
